import React from "react";

export default function DivisionCmp(props: any) {
  return (
    <div
      // className={props.className ? props.className : "mTop30"}
      style={{
        width: "98%",
        margin: "-2vh auto 2vh",
        background: "rgb(255, 255, 255)",
        // paddingBottom: "2vh",
      }}
    >
      {props.title && (
        <span
          className="colorTitle fontWeight textFont16 mbottom10"
          style={{
            marginTop: "-10px",
            marginRight: "20px",
            background: "#fff",
            paddingRight: "5px",
            paddingLeft: "5px",
          }}
        >
          {props.title}
        </span>
      )}

      <div
        className="cardBorderTitle borderCOlor"
        style={{
          minHeight: props.minHeight,
          maxHeight: props.maxHeight,
          textAlign: props.textAlign,
          alignItems: props.alignItems,
          display: props.display,
        }}
      >
        {props.child}
      </div>
    </div>
  );
}
